import { useEffect } from 'react';
import { removeEntity, removeFeature } from '@redux/entity/entity-reducer';
import { useDispatch } from 'react-redux';
import { removedFeaturesHighlighting } from '@redux/map/map-reducer';
import { clearedSelectedMapFeatures } from '@redux/showInfo/showInfoReducer';
import { usePresetsContext } from '@context/presetsContext';

type Props = {
    children: React.ReactElement;
    entityName: string;
};

const EntityManagerCleaner: React.FC<Props> = ({ children, entityName }) => {
    const { selectedPresetId } = usePresetsContext();
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            dispatch(removeEntity(entityName));
            dispatch(removeFeature({ entityName }));
            dispatch(removedFeaturesHighlighting());
            dispatch(clearedSelectedMapFeatures());
        };
    }, [entityName, selectedPresetId]);

    return <>{children}</>;
};

export default EntityManagerCleaner;
